import { NgModule } from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {TranslationDynamicComponentHelper} from './translation-dynamic-component-helper';
import {translationRoutes} from './translation.routes';
import {translationReducer} from './store/reducers/translation.reducers';
import {TranslationEffects} from './store/effects/translation.effects';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {TranslationService} from './services/translation.service';
import {CommonModule} from '@angular/common';
import {TranslationCurrencyConversionService} from "./services/translation-currency-conversion.service";
import {TranslationSettingComponent} from "./components/dialogs/translation-setting/translation-setting.component";
import {FxRateDialogComponent} from "./components/dialogs/fx-rate-dialog/fx-rate-dialog.component";
import { TranslationDownloadDialogComponent } from './components/dialogs/translation-download-dialog/translation-download-dialog.component';
import { TranslationComponent } from './components/translation/translation.component';
import {TranslationGridHandler} from "./services/translation-grid.handler";
import {TranslationViewHandler} from "./services/translation-view.handler";
import { TranslatedFormComponent } from './components/translated-form/translated-form.component';
import { OriginalFormComponent } from './components/original-form/original-form.component';
import {TranslationUIService} from "./services/translation-ui.service";
import { TranslationDownloadActionCellViewerComponent } from './components/translation-download-action-cell-viewer/translation-download-action-cell-viewer.component';
import { ActionButtonDialogComponent } from './components/dialogs/action-button-dialog/action-button-dialog.component';
import { UpdateTranslationSettingComponent } from './components/dialogs/update-translation-setting/update-translation-setting.component';
import { TranslationCompareDialogComponent } from './components/dialogs/translation-compare-dialog/translation-compare-dialog.component';
import { TranslationConvertCurrencyDialogComponent } from './components/dialogs/translation-convert-currency-dialog/translation-convert-currency-dialog.component';
import { TranslationStatusCellViewerComponent } from './components/cell-viewer/translation-status-cell-viewer/translation-status-cell-viewer.component';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {SelectTranslationLanguageComponent} from "@features/translation/components/dialogs/select-translation-language-dialog/select-translation-language.component";
import {TranslationCommandHandler} from '@features/translation/services/translation-command-handler';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';

@NgModule({
  declarations: [
    TranslationSettingComponent,
    SelectTranslationLanguageComponent,
    FxRateDialogComponent,
    TranslationDownloadDialogComponent,
    TranslationComponent,
    TranslatedFormComponent,
    OriginalFormComponent,
    TranslationDownloadActionCellViewerComponent,
    ActionButtonDialogComponent,
    UpdateTranslationSettingComponent,
    TranslationCompareDialogComponent,
    TranslationConvertCurrencyDialogComponent,
    TranslationStatusCellViewerComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(translationRoutes),
    StoreModule.forFeature('translation', translationReducer),
    EffectsModule.forFeature([TranslationEffects]),
  ],
  exports: [
    TranslationSettingComponent,
    SelectTranslationLanguageComponent,
    FxRateDialogComponent,
    TranslationDownloadDialogComponent,
    OriginalFormComponent,
    TranslationComponent,
    TranslationDownloadActionCellViewerComponent,
    UpdateTranslationSettingComponent,
    ActionButtonDialogComponent,
    TranslationCompareDialogComponent,
    TranslationConvertCurrencyDialogComponent,
    TranslationStatusCellViewerComponent],
  providers: [TranslationService, TranslationCurrencyConversionService, TranslationUIService]
})
export class TranslationModule {
  constructor(private translationGridHandler: TranslationGridHandler, translationViewHandler: TranslationViewHandler,  private commandService: CommandService, private translationCommandHandler: TranslationCommandHandler,
              private platformApiProvider: PlatformApiProvider) {
    // The translation pages' links live under TranslationApi; without this the route resolves to no api.
    this.platformApiProvider.registerDefault('TranslationApi', '/translation');
    TranslationDynamicComponentHelper.init();
    TranslationDynamicComponentHelper.register('TranslationGridHandler', translationGridHandler);
    TranslationDynamicComponentHelper.register('TranslationViewHandler', translationViewHandler);
    TranslationDynamicComponentHelper.register('TranslationCommandHandler', translationCommandHandler);

    const command = new PlatformCommand('CreateTranslationToolLinkCommand', 'TranslationApi');
    this.commandService.registrPlatformLinkCommand('/translation', command);
    const viewCommand = new PlatformCommand('CreateViewTranslationLinkCommand', 'TranslationApi');
    this.commandService.registrPlatformLinkCommand('/translation/:translationId', viewCommand);
    this.commandService.registrPlatformLinkCommand('/translation/view/:translationId', viewCommand);
  }
}
